module.exports = __webpack_public_path__ + "img/check blanco.6775c93f.svg";